// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ovwp","icon":"styles_icon__16gvT"};